// extracted by css-extract-rspack-plugin
export default {"cls1":"session_trail-cls1_2Fi","cls2":"session_trail-cls2_5em session_trail-cls1_2Fi"};